// Partner-scoped announcements — visible to the desktop users of every tenant
// this partner owns, and to no one else.
//
// Lives in the PARTNER-ADMIN console (`PartnerScreen`). The platform-admin
// branch of the same sidebar entry (`PartnersScreen`, partner CRUD) deliberately
// has no announcements tab: a platform admin publishes on its own surface.

import type { AdminHttpClient } from '../../http.js';
import type { ToastMessage } from '../../types.js';
import { AnnouncementsManager } from '../announcements/AnnouncementsManager.js';

export function PartnerAnnouncementsTab({
  http,
  onToast,
  active,
}: {
  http: AdminHttpClient;
  onToast: (toast: ToastMessage) => void;
  active: boolean;
}) {
  return (
    <AnnouncementsManager
      http={http}
      scope="partner"
      canWrite
      onToast={onToast}
      active={active}
    />
  );
}
